import React from "react";
import styles from "./FormSections/FormSections.module.css";
import { useCurrentStageStatus, useRequestPriority } from "../../../hooks/index";

const RequestBadges = ({ referenceNumber, requestProgressId, persona, requestId }) => {  
  const {
    priority = "-",
    remainingDays,
    isLoading,
  } = useRequestPriority(requestProgressId, persona);
  
  const { loading: isProgressLoading, data: currentStageStatus } = useCurrentStageStatus(requestId, persona);

  if(isProgressLoading || currentStageStatus?.status?.includes("approved") || currentStageStatus?.status?.includes("rejected")){
    return <></>
  }
  
  const displayPriority = isLoading ? "Loading..." : priority || "-";
  const capitalizedPriority = displayPriority && displayPriority !== "-" && displayPriority !== "Loading..." 
    ? displayPriority.charAt(0).toUpperCase() + displayPriority.slice(1) 
    : displayPriority;
  
  const getPriorityBadgeClass = (priority) => {
    switch(priority) {
      case "critical":
        return `${styles.badge} ${styles.priorityBadgeCritical}`;
      case "high":
        return `${styles.badge} ${styles.priorityBadgeHigh}`;
      case "medium":
        return `${styles.badge} ${styles.priorityBadgeMedium}`;
      case "low":
        return `${styles.badge} ${styles.priorityBadgeLow}`;
      default:
        return `${styles.badge} ${styles.priorityBadge}`;
    }
  };

  const displayDays = isLoading
    ? "--"
    : typeof remainingDays === "number"
    ? remainingDays.toString().padStart(2, "0")
    : "--";
  return (
    <div className={styles.badgeContainer}>
      <span className={getPriorityBadgeClass(priority)}>Priority: {capitalizedPriority}</span>
      <span className={styles.badge}>#{referenceNumber || "-"}</span>
      {priority !== "low" && <span className={styles.badge}>{displayDays} Days</span>}
    </div>
  );
};

export default RequestBadges; 